const queryString = require("query-string");
import * as _ from "lodash";

// configs
import QuestionConfig from "../question/QuestionConfig";
import ActivityConfig from "../activity/ActivityConfig";
import ItemConfig from "../item/ItemConfig";

// types
import { ContentTypes, IManifest } from "../../TypesAndIdentifiers";

export default class ContentConfig {
    private DEFAULT_MANIFEST: IManifest = {
        modules: [
            "pls-ucsd"
        ]
    };
    public contentType: ContentTypes;
    public targetConfig: any;
    constructor(public contentProps) {
        // Convert contentTypes enum to array
        const contentTypes: any = _.values(ContentTypes);

        // Get content type from contentID by searching sub-string
        [this.contentType] = contentTypes.filter(contentType =>
            this.contentProps.type.includes(contentType)
        );

        // Set config as per matching content type
        switch (this.contentType) {
            case ContentTypes.QUESTION:
                this.targetConfig = new QuestionConfig(this.contentProps);
                break;
            case ContentTypes.ITEM:
                this.targetConfig = new ItemConfig(this.contentProps);
                break;
            case ContentTypes.ACTIVITY:
                this.targetConfig = new ActivityConfig(this.contentProps);
                break;
            default:
                console.error("ContentType is not identifiable : ", this.contentType);
        }
        this.targetConfig.setAttributesAndStates(this.contentProps.attributes);
        this.targetConfig.manifest = this.DEFAULT_MANIFEST;
    }
}
